import * as React from 'react'
import { type ClassicScheme, Presets } from 'rete-react-plugin'
import { css } from '@emotion/react'
import { colors } from '@retailer-platform/shared-components'
const { Connection } = Presets.classic

const styles = css({
  stroke: colors.SECONDARY.LIGHT,
  strokeDasharray: '10 5',
  animation: 'dash 1s linear infinite',
  strokeDashoffset: 45,
  '@keyframes dash': {
    to: {
      strokeDashoffset: 0,
    },
  },
})

export function PipelineEditorConnection(props: {
  data: ClassicScheme['Connection'] & { isLoop?: boolean }
}) {
  return <Connection {...props} styles={() => styles} />
}
